import type { StaticImageData } from 'next/image';
import NoReportsFoundSVG from '../../../public/img/illustrations/reports.svg';
import NoTransactionsAddedYetSVG from '../../../public/img/illustrations/three-cards.svg';
import NoTransactionsFoundSVG from '../../../public/img/illustrations/three-cards-with-magnifying-glass.svg';

export enum ErrorPageType {
  ServerError = 'server-error',
  InteractionError = 'interaction-error',
  NoTransactionsFound = 'no-transactions-found-error',
  NoTransactionsAdded = 'no-transactions-added-error',
  NoArchivedTransactionsFound = 'no-archived-transactions-found-error',
  NoArchivedTransactionsAdded = 'no-archived-transactions-added-error',
  NoReportsFound = 'no-reports-were-found',
}

type ErrorTypeToStringMap = Record<ErrorPageType, string | null>;
type ErrorTypeToImageMap = Record<ErrorPageType, StaticImageData | null>;

export const ErrorPageTitles: ErrorTypeToStringMap = {
  [ErrorPageType.ServerError]: 'Server Error',
  [ErrorPageType.InteractionError]: 'Transaction Not Found',
  [ErrorPageType.NoTransactionsFound]: 'No Transactions Found',
  [ErrorPageType.NoTransactionsAdded]: 'No Transactions Yet',
  [ErrorPageType.NoArchivedTransactionsFound]: 'No Archived Transactions Found',
  [ErrorPageType.NoArchivedTransactionsAdded]: 'No archived transactions',
  [ErrorPageType.NoReportsFound]: 'No Reports Available',
};

export const ErrorPageSubtitles: ErrorTypeToStringMap = {
  [ErrorPageType.ServerError]: 'Something went wrong on our end',
  [ErrorPageType.InteractionError]: null,
  [ErrorPageType.NoTransactionsFound]:
    'Try searching again or changing your filter selections',
  [ErrorPageType.NoTransactionsAdded]: 'Add a transaction to get started',
  [ErrorPageType.NoArchivedTransactionsFound]:
    'Try searching again or changing your filter selections',
  [ErrorPageType.NoArchivedTransactionsAdded]:
    'Archive a transaction on the homepage to find it here',
  [ErrorPageType.NoReportsFound]: 'There are no reports for this account.',
};

export const ShowSideSupportLink = {
  [ErrorPageType.ServerError]: false,
  [ErrorPageType.InteractionError]: true,
  [ErrorPageType.NoTransactionsFound]: false,
  [ErrorPageType.NoTransactionsAdded]: false,
  [ErrorPageType.NoArchivedTransactionsFound]: true,
  [ErrorPageType.NoArchivedTransactionsAdded]: false,
  [ErrorPageType.NoReportsFound]: true,
};

export const ErrorPageImages: ErrorTypeToImageMap = {
  [ErrorPageType.ServerError]: null,
  [ErrorPageType.InteractionError]: null,
  [ErrorPageType.NoTransactionsFound]:
    NoTransactionsFoundSVG as StaticImageData,
  [ErrorPageType.NoTransactionsAdded]:
    NoTransactionsAddedYetSVG as StaticImageData,
  [ErrorPageType.NoArchivedTransactionsFound]:
    NoTransactionsFoundSVG as StaticImageData,
  [ErrorPageType.NoArchivedTransactionsAdded]:
    NoTransactionsAddedYetSVG as StaticImageData,
  [ErrorPageType.NoReportsFound]: NoReportsFoundSVG as StaticImageData,
};
